<template>
  <b-container fluid>
    <b-row>
      <b-col sm="12" md="7" lg="5" id="login-form" class="p-3 p-lg-4 p-xl-5">
        <b-row>
          <b-col cols="12" md="4" class="text-center text-lg-left py-3" align-self="center">
            <img :src="$store.getters.ecosystem.logoLogin" :alt="$store.getters.ecosystem.siteName" style="height: 100%; max-height: 50px; width: auto; max-width: 150px;">
          </b-col>
          <b-col cols="12" md="8" class="text-center text-md-right text-muted py-3 py-md-5" align-self="center">
            <translate>Already have an account?</translate>
            <b-link :to="{ name: 'login' }" class="text-uppercase" style="vertical-align:baseline">
              <strong>
                <translate>Log in</translate>
              </strong>
            </b-link>
          </b-col>
        </b-row>
        <register-form class="pt-5" />
      </b-col>
      <b-col sm="12" md="5" lg="7" id="login-bg" class="d-none d-md-block">

      </b-col>
    </b-row>
  </b-container>
</template>
<script>
import RegisterForm from '@/components/RegisterForm'

export default {
  name: 'RegisterPage',
  title() {
    return this.$gettext('Create a new account')
  },
  components: {
    RegisterForm
  }
}
</script>
